import React, { useState, useEffect, Fragment } from 'react';
import { CellStyle, UpdateInventoryButton, UpdateCellInput } from '../Layout';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Inventory } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'reactstrap';

function TimeSlot({
    slot,
    handleUpdate,
}) {
    const [val, setVal] = useState(slot);
    const [style, setStyle] = useState({});
    return (
        <Fragment>
            <CellStyle
                style={style}
            >
                <Row>
                    <Col md={12}>
                        {val.timeSlot}
                    </Col>
                </Row>
                <Row className="my-2 justify-content-center">
                    <Col md={6}>
                        <Input type="number" min={0} value={val.inventory} onChange={(e) => {
                            setVal({ ...val, inventory: e.target.value });
                            handleUpdate(e.target.value, val.timeSlot);
                        }}>
                        </Input>
                    </Col>
                </Row>
            </CellStyle>
        </Fragment >
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, currency } = settings;
    return {
        propertyId,
        currency
    };
};

export default injectIntl(connect(mapStateToProps, {})(TimeSlot));
